import type { Card } from '@/types'
import { formatLidForDisplay } from '@/utils/lid'
import './EdgeCardPreview.css'

export type EdgeDirection = 'left' | 'right' | 'up' | 'down'

interface EdgeCardPreviewProps {
  card: Card | null
  direction: EdgeDirection
  onClick: () => void
  isHighlighted?: boolean
}

const directionConfig = {
  left: {
    arrow: '←',
    key: 'h',
    label: 'Parent',
  },
  right: {
    arrow: '→',
    key: 'l',
    label: 'Child',
  },
  up: {
    arrow: '↑',
    key: 'k',
    label: 'Prev',
  },
  down: {
    arrow: '↓',
    key: 'j',
    label: 'Next',
  },
}

export function EdgeCardPreview({
  card,
  direction,
  onClick,
  isHighlighted = false,
}: EdgeCardPreviewProps) {
  // Don't render if no card
  if (!card) return null

  const config = directionConfig[direction]
  const isHorizontal = direction === 'left' || direction === 'right'

  return (
    <button
      className={`edge-card edge-card--${direction} ${isHighlighted ? 'edge-card--highlighted' : ''}`}
      onClick={onClick}
      title={`${config.arrow} ${card.title}`}
    >
      <div className="edge-card__shortcut">
        <span className="edge-card__arrow">{config.arrow}</span>
        <kbd>{config.key}</kbd>
      </div>
      <div className="edge-card__lid">{formatLidForDisplay(card.lid)}</div>
      {isHorizontal && (
        <div className="edge-card__title">{card.title}</div>
      )}
      {!isHorizontal && (
        <div className="edge-card__title-inline">{card.title}</div>
      )}
    </button>
  )
}
